import { CopyButton, SwitchAppButton } from "../../../components";

import closeIcon from "../../../assets/icons/close-circle.svg";
import { IResolveBankAccountResponse } from "../../../interfaces-and-types";
import { useCheckoutPage } from "../../../hooks";
import { useEffect } from "react";

interface IBankTransferOptionsProps {
  closeVirtualBankAccountsView: () => void;
  gatewayReservedVirtualAccounts?: IResolveBankAccountResponse[];
  setBankTransferCompleted: () => void;
}

export const BankTransferOptions = (props: IBankTransferOptionsProps) => {
  const isRenderedInIframe = window.self !== window.top;

  // hide/show the switcher when user enters/leaves view
  const { showPaymentMethodSwitcher, hidePaymentMethodSwitcher } =
    useCheckoutPage();

  useEffect(() => {
    hidePaymentMethodSwitcher();

    return () => showPaymentMethodSwitcher();
  }, []);

  return (
    <div className="flex-container col align-items--stretch">
      <div className="flex-container justify-content--between align-items--center mt-5">
        <button
          className="close-bankaccounts--button"
          onClick={props.closeVirtualBankAccountsView}
          title="close and try another payment provider"
          type="button"
        >
          <img
            src={closeIcon}
            alt="close page"
            className="close-iframe--icon"
          />
        </button>
        <h6 className="ml-5">Transfer To Any Of The Account Number(s) Below</h6>
      </div>

      <div className="guide-container flex-container col align-items--center bordered">
        <strong className="font-ctm--extrabold text-danger">
          PLEASE, TRANSFER THE EXACT AMOUNT!
        </strong>
        <strong className="switchapp-small">Then click the button below</strong>

        <strong className="mt-5 text-primary">
          Do not save these account number(s)
        </strong>
        <span>All account number(s) will expire after payment</span>
      </div>

      <div
        className={`gateway-links--container bank-accounts-list col heavy-padding-${
          3 - (props.gatewayReservedVirtualAccounts?.length || 0)
        }`}
      >
        {props.gatewayReservedVirtualAccounts
          ?.sort((acc1, acc2) =>
            acc1.bank_name < acc2.bank_name
              ? -1
              : acc1.bank_name > acc2.bank_name
              ? 1
              : 0
          )
          .map((acc, index) => (
            <div
              key={acc.bank_code}
              className={`bankaccount-container bordered pl-5 pt-5 pb-5 b-r-5 mt-5 mb-5 animated-item-${index}`}
            >
              <div className="flex-container justify-content--center mb-3">
                <strong className="bank-name switchapp-small font-ctm--black fixed-length-display">
                  {acc.bank_name.toUpperCase()}
                </strong>
              </div>
              <div className="flex-container justify-content--center mb-5">
                <div className="flex-container justify-content--start align-items--center no-wrap">
                  <strong className="account-number fixed-length-display font-ctm--bold">
                    {acc.account_number}
                  </strong>
                  {isRenderedInIframe ? null : (
                    <div className="ml-3">
                      <CopyButton
                        name="copy-account-button"
                        stringToCopy={acc.account_number}
                        iconDescription="copy account number"
                        className="copy-btn"
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="flex-container align-items--center col">
                <span className="switchapp-small">Account Name: </span>
                <strong className="account-name fixed-length-display font-ctm--bold text--center">
                  {acc.account_name.toUpperCase()}
                </strong>
              </div>
            </div>
          ))}
      </div>

      <div className="flex-container buttons-container mt-5">
        <SwitchAppButton
          onClick={props.setBankTransferCompleted}
          className="flex-box"
        >
          <strong>I Have Completed Transfer</strong>
        </SwitchAppButton>
      </div>
    </div>
  );
};
